export const navList = [
    {
        label: "Home",
        path: "##"
    },
    {
        label: "Services",
        path: "##"
    },
    {
        label: "About Us",
        path: "##"
    },
    {
        label: "Contact Us",
        path: "##"
    },
]

